const loadingLevelIdReducer = (levelId = null, action) => {
    switch(action.type){
        case 'LOADING_LEVEL_ID':
            return action.data;
        default:
            return levelId;
    }
}

export default loadingLevelIdReducer